// extracted by mini-css-extract-plugin
var _1 = "ForgotView-module__animatedBackground--kUetZ";
var _2 = "ForgotView-module__emailDescription--HKXno";
var _3 = "ForgotView-module__resetLinkButton--hMa6h";
var _4 = "ForgotView-module__successMessage--MYf0P";
export { _1 as "animatedBackground", _2 as "emailDescription", _3 as "resetLinkButton", _4 as "successMessage" }
